interface LoadingOverlayProps {
  readonly title?: string | undefined;
  readonly message: string;
  readonly progress: number;
  readonly variant?: "loading" | "error" | undefined;
}

export function LoadingOverlay({
  title = "読み込み中です",
  message,
  progress,
  variant = "loading",
}: LoadingOverlayProps): JSX.Element {
  const safeProgress = Math.min(100, Math.max(0, Math.round(progress)));
  const isError = variant === "error";

  return (
    <div
      className="loading-overlay"
      data-testid="loading-overlay"
      role={isError ? "alert" : "status"}
      aria-live={isError ? "assertive" : "polite"}
      aria-busy={!isError}
    >
      <div className="loading-overlay-panel">
        {isError ? (
          <span className="loading-overlay-error-mark" aria-hidden="true">
            !
          </span>
        ) : (
          <span className="loading-overlay-spinner" aria-hidden="true" />
        )}
        <div className="loading-overlay-copy">
          <p className="loading-overlay-title">{title}</p>
          <p className="loading-overlay-message">{message}</p>
        </div>
        <div className="loading-overlay-progress" aria-label={`読み込み進捗 ${safeProgress}%`}>
          <span style={{ width: `${safeProgress}%` }} />
        </div>
        <span className="loading-overlay-percent">{safeProgress}%</span>
      </div>
    </div>
  );
}
